import { findedLocation, getLocalStorage } from "../helpers/Helper";
import axios from "axios";

let token = getLocalStorage()?.Token;
let apiBaseURL = "";
let securityKey = ""
let userAPIKey = token ? "Bearer " + token :securityKey;

const loadConfig = async () => {
    const response = await fetch("/config.json");
    const config = await response.json();
    apiBaseURL = config.API_BASE_URL;
    securityKey = config.API_SECURE_KEY
};

const createHttpInstance = async () => {
    await loadConfig();
    return axios.create({
      baseURL: apiBaseURL,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": userAPIKey,
        "Cache-Control": "no-store, no-cache, must-revalidate",
        "LanguageCode": findedLocation().LanguageCode,
        "CountryCode": findedLocation().CountryCode,
      },
    });
  };

  export default createHttpInstance;